import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useWheelHistory } from '../hooks/useLocalStorage';
import { X, Trash2, Clock } from 'lucide-react';

const HistoryPanel = ({ onClose }) => {
  const { t } = useLanguage();
  const { history, clearHistory, removeFromHistory } = useWheelHistory();

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="panel history-panel" data-testid="history-panel">
      <div className="panel-header">
        <h3>
          <Clock size={20} />
          {t('wheel.history')}
        </h3>
        <div className="panel-actions">
          {history.length > 0 && (
            <button 
              onClick={clearHistory} 
              className="btn-clear-history"
              aria-label={t('wheel.clearHistory')}
              data-testid="clear-history-button"
            >
              <Trash2 size={16} />
              {t('wheel.clearHistory')}
            </button>
          )}
          <button onClick={onClose} className="btn-panel-close" aria-label="Close">
            <X size={20} />
          </button>
        </div>
      </div>
      
      <div className="panel-content">
        {history.length === 0 ? (
          <p className="no-history" data-testid="no-history">
            {t('wheel.noHistory')}
          </p>
        ) : (
          <ul className="history-list" data-testid="history-list">
            {history.map((item, index) => (
              <li key={item.id} className="history-item" data-testid={`history-item-${index}`}>
                <span 
                  className="history-color" 
                  style={{ backgroundColor: item.color || '#4ECDC4' }}
                  aria-hidden="true"
                />
                <div className="history-info">
                  <span className="history-result">{item.result}</span>
                  <span className="history-time">{formatTime(item.timestamp)}</span>
                </div>
                <button
                  onClick={() => removeFromHistory(item.id)}
                  className="btn-remove-history"
                  aria-label="Remove from history"
                >
                  <X size={14} />
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default HistoryPanel;
